const trainsKey = 'sdx-trains'

// 获取本地缓存的trains
const getTrains = () => {
  return JSON.parse(window.localStorage.getItem(trainsKey))
}

const setTrains = trains => {
  return window.localStorage.setItem(trainsKey, JSON.stringify(trains))
}

// trains 为row trainList location 为本地缓存
const getUnPreloadedTrains = (trains, localTrains) => {
  localTrains = localTrains || []

  // 将row trains添加对应属性
  const newTrains = trains.map(train => {
    return {
      ...train,
      isPreLoaded: false, // 默认都是没有预加载
      percentage: 0, //加载状况为0
    }
  })
  //
  newTrains.forEach(train => {
    localTrains.find(localTrain => {
      // 先查找是否存在对应本地缓存的train
      if (localTrain.trainId === train.trainId) {
        // 判断本地上次缓存的时间,小于7天
        if (
          //todo question 没有location.date
          localTrain.date &&
          Date.now() - localTrain.date < 7 * 24 * 3600 * 1000
        ) {
          train.date = localTrain.date
          train.isPreLoaded = localTrain.isPreLoaded
          train.duration = localTrain.duration
        }
        return true
      }
    })
  })
  return newTrains
}

// 预加载
const preLoadIframe = (
  trains,
  status,
  iframe,
  { success = () => {}, timeout = 30, avgTime }
) => {
  // 找到没有加载完成的,进行加载
  const trainIndex = trains.findIndex(item => item.isPreLoaded === false) // false
  if (trainIndex === -1) {
    iframe.parentNode.removeChild(iframe)
    status.preLoading = false
    success({ trainIndex })
    return
  }

  // todo mute=1 参数作用是?
  iframe.src = `${process.env.VUE_APP_TRAIN_PREFIX}${
    trains[trainIndex].trainPath
  }?mute=1`
  const startTime = Date.now()

  // 失败的计时器
  const failedTimer = window.setTimeout(() => {
    window.clearInterval(percentageTimer)
    window.removeEventListener('message', handleIframeLoad)
    trains[trainIndex].percentage = 100
    success({ trainIndex, trains, startTime })
    window.setTimeout(() => {
      trains[trainIndex].isPreLoaded = 'failed'
      trains[trainIndex].duration = Date.now() - startTime
      status.failed += 1
      setTrains(trains)
      preLoadIframe(trains, status, iframe, { success, timeout, avgTime })
    }, 1000)
  }, timeout * 1000)

  // todo question 这儿的逻辑是?
  const percentageInterval = 0.5

  // 设置百分比计时器
  const percentageTimer = window.setInterval(() => {
    let piece
    const timeGrow = 1.2
    const stopPercentage = (1 / timeGrow) * 100 //加载临界值

    // 计算加载量
    if (trains[trainIndex].percentage < stopPercentage) {
      piece = (percentageInterval / (avgTime * timeGrow)) * 100 // 小于临界值则用平均值计算0.5秒加载量
    } else {
      piece =
        (percentageInterval / (timeout - avgTime)) * (100 - stopPercentage) // 大于则用另一种算法算加载量
    }

    // 计算对应百分比值/s
    trains[trainIndex].percentage = Number(
      (trains[trainIndex].percentage + piece).toFixed(2)
    )

    //满了则加载完毕
    if (trains[trainIndex].percentage > 100) {
      trains[trainIndex].percentage = 100
    }
  }, percentageInterval * 1000)

  function handleIframeLoad(event) {
    if (event.data.action !== 'resourceOnload') return
    window.clearTimeout(failedTimer)
    window.clearInterval(percentageTimer)
    window.removeEventListener('message', handleIframeLoad)
    trains[trainIndex].percentage = 100
    success({ trainIndex, trains, startTime })
    // 给动画留时间
    window.setTimeout(() => {
      trains[trainIndex].isPreLoaded = true
      trains[trainIndex].date = Date.now()
      trains[trainIndex].duration = Date.now() - startTime
      status.preLoaded += 1
      setTrains(trains)
      console.log(Date.now() - startTime, '成功')
      preLoadIframe(trains, status, iframe, { success, timeout, avgTime })
    }, 1000)
  }

  window.addEventListener('message', handleIframeLoad, false)
}

// 创建iframe元素
const creatIframe = (id = 'preload') => {
  document.querySelectorAll(`iframe#${id}`).forEach(iframe => {
    iframe.parentNode.removeChild(iframe)
  })
  const iframe = document.createElement('iframe')
  iframe.id = id
  iframe.style.position = 'absolute'
  iframe.style.top = '0'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = '0'
  return iframe
}

export {
  getTrains,
  setTrains,
  getUnPreloadedTrains,
  preLoadIframe,
  creatIframe,
}
